// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_eO","advertDetailHeaderPrice__value":"c-m_eP","advertDetailHeaderPrice__label":"c-m_eQ"};